<template>
      <card>
        <list
          :columns="columns"
          :modalCreate="modalCreate"
          :removeLink="removeLink"
          :cardLink="cardLink"
          :isUpdate="true"
          :isAdd="true"
          :itemLink="itemLink"
          :setLink="setLink"
          :fields="fields"
          :searchDisable="true"
          @change="change"
          @changeFunction="changeFunction"
          v-model="val"
        />
      </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "post",
      fields: [
               {
            col:' col-12 col-md-12',
            key: "title",
            label: "Название",
            type: "field",
            textType: "text",
            isMultiLang:true
          },
                {
                key: "position",
                label: "Позиция",
                type: "field",
                textType: "number",
                
              },
                {
                key: "code",
                label: "Ссылка",
                type: "field",
                textType: "text",
                
              },
            {
                col:' col-12 col-md-4 ',
                key: "image",
                label: "Изображение (2:1)",
                type: "img",
                 isMultiLang:true
            },
               {
            col:' col-12 col-md-12',
            key: "annotation",
            label: "Краткое описание",
            type: "textarea",
            textType: "text",
            isMultiLang:true
          },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_post",
      itemLink: "posts",
      setLink: "posts",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          sortBy:'id'
        },
        {
          key: "title",
          title: "Название",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          sortBy:'id'
        },
    
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
